import React, { memo } from "react";
import NativeSelect from "@mui/material/NativeSelect";
import CustomInput from "../CustomInput";

const CustomDropdown = (props) => {
  return (
    <NativeSelect {...props} input={<CustomInput sx={props.inputsx} />}>
      {props.children}
    </NativeSelect>
  );
};

export default memo(CustomDropdown);
